<template>
  <button
    :id="id"
    :type="type"
    :class="computedClasses"
    :disabled="disabled || loading"
    :aria-pressed="pressed"
    data-testid="bs-button"
    @click="handleClick"
  >
    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    <span v-if="loading" class="sr-only">Loading...</span>
    <span v-html="htmlContent" v-if="htmlContent"></span>
    <slot v-else />
  </button>
</template>

<script>
export default {
  name: 'BsButton',
  props: {
    id: {
      type: String,
      default: null,
    },
    variant: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: null,
      validator: (value) => ['sm', 'lg'].includes(value),
    },
    type: {
      type: String,
      default: 'button',
      validator: (value) => ['button', 'submit', 'reset'].includes(value),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pressed: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    pill: {
      type: Boolean,
      default: false,
    },
    squared: {
      type: Boolean,
      default: false,
    },
    htmlContent: {
      type: String,
      default: null,
    },
  },
  computed: {
    computedClasses() {
      const classes = ['btn'];

      // Add variant class
      if (this.variant) {
        classes.push(`btn-${this.variant}`);
      }

      // Add size class
      if (this.size) {
        classes.push(`btn-${this.size}`);
      }

      // Add utility classes
      if (this.block) {
        classes.push('w-100');
      }
      if (this.pill) {
        classes.push('rounded-pill');
      }
      if (this.squared) {
        classes.push('rounded-0');
      }
      if (this.pressed) {
        classes.push('active');
      }

      return classes;
    },
  },
  methods: {
    handleClick(event) {
      if (this.disabled || this.loading) {
        event.preventDefault();
        return;
      }
      this.$emit('click', event);
    },
  },
};
</script>

<style scoped>
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
</style>